import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';
import { name, FetchList } from '@store/system/service';
var Slice = createSlice({
    name: name,
    initialState: { data: {} },
    reducers: {},
    extraReducers: function (builder) {
        /** 发起查询请求 */
        builder
            .addCase(FetchList.pending, function (state) {
            state.fetching = true;
            delete state.fetchingError;
        })
            .addCase(FetchList.fulfilled, function (state, action) {
            state.fetching = false;
            state.data = action.payload;
        })
            .addCase(FetchList.rejected, function (state, action) {
            state.fetching = false;
            state.fetchingError = action.error.message;
        });
    },
});
var stateSelector = createSelector(function (state) { return state; }, function (state) { return state.system; });
var systemSelector = createSelector(function (state) { return state; }, function (state) {
    return state.data || {};
});
export var useSystemState = function () {
    return useSelector(stateSelector);
};
export var useStatus = function (action) {
    return useSystemState()[action];
};
export var useError = function (action) {
    var state = useSystemState();
    var error = null;
    switch (action) {
        case 'fetching':
            error = state.fetchingError;
            break;
        default:
            break;
    }
    return error;
};
export var useList = function () {
    var state = useSystemState();
    return systemSelector(state);
};
export var reducer = Slice.reducer, actions = Slice.actions;
